import { Dialog } from '@material-ui/core';
import React from 'react';

import {
  REVIEW_STATUS_ALLOWED,
  REVIEW_STATUS_BLOCKED,
  REVIEW_STATUS_REVIEWED,
  REVIEW_STATUS_UNREVIEWED,
} from '~/src/dash/api/creative-validation';
import { CloseButton } from '~/src/dash/components/buttons/commonButtons/CloseButton';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { ButtonV2, Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { graphColors, publicaColors } from '~/src/dash/utils/colors';
import { createAction } from '~/src/dash/views/brand-safety/creative-review/config';

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleUpdate: (newReviewStatus: number) => void;
  selectedNum: number;
  newReviewStatus: number;
}

export const BatchUpdateModal = ({
  open,
  handleClose,
  handleUpdate,
  selectedNum,
  newReviewStatus,
}: IProps): JSX.Element => {
  let action = createAction(REVIEW_STATUS_UNREVIEWED, 'Unreview', 'undo', publicaColors.black);
  switch (newReviewStatus) {
    case REVIEW_STATUS_UNREVIEWED:
      break;
    case REVIEW_STATUS_ALLOWED:
      action = createAction(REVIEW_STATUS_ALLOWED, 'Allow', 'unlock', graphColors.green);
      break;
    case REVIEW_STATUS_BLOCKED:
      action = createAction(REVIEW_STATUS_BLOCKED, 'Block', 'unavailable', publicaColors.red);
      break;
    case REVIEW_STATUS_REVIEWED:
      action = createAction(
        REVIEW_STATUS_REVIEWED,
        'Review',
        'available',
        graphColors.lavenderPurple,
      );
      break;
    default:
      break;
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-update-preset'
      aria-describedby='alert-dialog-update-preset'
    >
      <Rows largePadding gap={spacing.base} style={{ minWidth: '600px' }}>
        <Row noPadding>
          <Cols style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Col>
              <Text bold>Confirm Action</Text>
            </Col>
            <Col>
              <CloseButton onClick={handleClose} />
            </Col>
          </Cols>
        </Row>
        <Row noPadding>
          <Text small>Please confirm if you would like to proceed with the following?</Text>
        </Row>
        <Row noPadding>
          <Cols
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              paddingRight: spacing.small,
              paddingLeft: spacing.base,
              gap: spacing.extraSmall,
            }}
          >
            <Col displayFlex>
              <IconV2
                name={action.iconName}
                color={action.color}
                style={{ marginRight: spacing.extraSmall }}
                large
              />
            </Col>
            <Col>
              <Text bold color={action.color}>
                {action.text}
              </Text>
            </Col>
          </Cols>
        </Row>
        <Row noPadding>
          <Text style={{ paddingLeft: spacing.base, gap: spacing.large }} small bold>
            {`${selectedNum} creatives`}
          </Text>
        </Row>
        <Row noPadding>
          <Cols gap={spacing.large} style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
            <Col>
              <ButtonV2 small onClick={() => handleUpdate(newReviewStatus)}>
                Confirm & Save
              </ButtonV2>
            </Col>
            <Col>
              <ButtonV2 small clearBackground onClick={handleClose} color={publicaColors.lightBlue}>
                Cancel
              </ButtonV2>
            </Col>
          </Cols>
        </Row>
      </Rows>
    </Dialog>
  );
};
